import { FC } from 'react';
import { IconProps } from '../../types';

export const IronSmall: FC<IconProps> = ({ width = 12, height = 12, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6003_117394)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
          fill="url(#paint0_linear_6003_117394)"
        />
        <path d="M5.38795 1.588H6.58795V9.988H5.38795V1.588Z" fill="#FBF4E7" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6003_117394"
          x1="5.6"
          y1="14.4"
          x2="5.6"
          y2="-2.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#402F2F" />
          <stop offset="0.239" stopColor="#615E67" />
          <stop offset="0.47" stopColor="#A8A2A2" />
          <stop offset="1" stopColor="#665454" />
        </linearGradient>
        <clipPath id="clip0_6003_117394">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
